import PlanEntryActiveListResponse, {
  PlanEntryActiveListResponseDataItem,
} from "../../../api/raily/plan-entry/active-list/plan-entry-active-list.response";
import PlanEntryActiveList, {
  PlanEntryActiveListItem,
} from "./plan-entry-active-list";

const createDataItem = (
  responseItem: PlanEntryActiveListResponseDataItem,
): PlanEntryActiveListItem => {
  return {
    uuid: responseItem.id,
    driverName: responseItem.driverName,
    taxiCorporationName: responseItem.taxiName,
    routeAddresses: responseItem.planEntryNodes,
    humanId: responseItem.humanId,
    startTime: responseItem.startTime,
    passengers: responseItem.involvedCargoLabels,
    cargoOrderHumanIds: responseItem.cargoOrderHumanIds,
  };
};

const createData = (
  responseData: PlanEntryActiveListResponseDataItem[],
): PlanEntryActiveListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: PlanEntryActiveListResponse): PlanEntryActiveList => {
  return {
    data: createData(response.data),
  };
};

const planEntryActiveListFactory = {
  create,
};

export default planEntryActiveListFactory;
